import styled from 'styled-components';
import theme from 'styles/theme';

export const CommonModalWrapper = styled.div`
  display: block;
  position: fixed;
  width: 100%;
  min-width: ${theme.layout.minWidth};
  max-width: ${theme.layout.maxWidth};
  min-height: 100dvh;
  top: 0;
  left: calc(50% + 12px);
  margin: 0;
  background: ${theme.backgroundColor.shadow};
  z-index: 100;

  @media screen and (max-width: 1200px) {
    left: 50%;
    transform: translateX(-50%);
    max-width: ${theme.layout.maxWidth};
  }

  .container {
    overflow: hidden;
    display: block;
    position: fixed;
    width: calc(100% - 40px);
    min-width: 265px;
    max-width: 440px;
    top: 50%;
    left: calc(50% + 35px);
    border-radius: 20px;
    transform: translateY(-50%);
    background: #ffffff;
    @media screen and (max-width: 1200px) {
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .btnClose {
      display: block;
      position: absolute;
      top: 12px;
      right: 20px;
      height: 24px;
      z-index: 10;
    }

    .content {
      overflow-y: auto;
      overflow-x: hidden;
      display: block;
      width: 100%;
      max-height: calc(100vh - 366px);
      background: ${theme.backgroundColor.white};
      padding: 40px 20px 30px;
      line-height: 2.4rem;
      font-size: 1.4rem;
      font-weight: ${props => (props.fontWeight ? props.fontWeight : 500)};
      text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
      color: ${theme.color.black};
      white-space: pre-line;
    }

    .btnGroupWrapper {
      display: flex;
      flex-direction: ${props => (props.isVerticalBtn ? 'column' : '')};
      justify-content: space-between;
      padding: ${props => (props.isVerticalBtn ? '0 20px' : '0px')};
      background: ${theme.backgroundColor.white};

      button {
        margin: ${props => (props.isVerticalBtn ? '0 20px 20px 0px' : '0px')};
        width: 100%;
        height: 54px;
        font-size: 1.6rem;
        text-align: center;
        font-weight: 600;
        color: ${theme.color.white};
        background: ${theme.backgroundColor.grey5};
        border-radius: ${props => (props.isVerticalBtn ? '10px' : '')};

        &.btnConfirm {
          background: ${theme.backgroundColor.blue};
          width: ${props => (props.width ? props.width : '100%')};
          &:disabled {
            background: ${theme.backgroundColor.buttonGrey};
          }
        }
      }
    }
  }
`;
